module.exports = __webpack_public_path__ + "img/ph.37b4d563.jpg";